import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  className?: string;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  className
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center" data-id="element-454">
      <div className="fixed inset-0 bg-black/60 transition-opacity" onClick={onClose} aria-hidden="true" data-id="element-455" />

      <div className={cn('relative w-full sm:max-w-lg max-h-[90vh] bg-white sm:rounded-2xl rounded-t-2xl shadow-lg flex flex-col anim-slide-up', className)} data-id="element-456">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100" data-id="element-457">
          {title ? <h2 className="text-lg font-semibold text-gray-900" data-id="element-458">{title}</h2> : <div data-id="element-459" />}
          <button onClick={onClose} className="p-2 -mr-2 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100 transition-colors" data-id="element-460">
            <X className="w-5 h-5" data-id="element-461" />
          </button>
        </div>

        <div className="overflow-y-auto p-6" data-id="element-462">{children}</div>
      </div>
    </div>;
}